import Fuse from 'fuse.js'

export const Search = (list: string[], x: string) => {
  if (x.length !== 0) {
    const options = {
      minMatchCharLength: 1,
      keys: ['info'],
    }
    const fuse = new Fuse(list, options)
    const pattern = x

    return (fuse.search(pattern))
  }
}
